import type React from 'react';
import { toast, type ExternalToast } from 'sonner';
import { type LogLevel } from '@types';
import { toastConfigByLevel } from './toastConfig';

type ToastFn = (message: React.ReactNode, options?: ExternalToast) => string | number;

function getToastFn (level: LogLevel): ToastFn {
  switch (level) {
  case 'success': return toast.success;
  case 'error':   return toast.error;
  case 'warning': return toast.warning;
  case 'info':    return toast.info;
  }
}

export function paintToast (
  level: LogLevel,
  message: string,
  toastOptions: ExternalToast = {}
): void {
  const fn = getToastFn(level);
  fn(message, {
    className: level,
    ...toastOptions,
    duration: toastOptions.duration ?? 5000,
    position: toastOptions.position ?? 'bottom-right',
    closeButton: true,
    style: toastConfigByLevel[level].style,
  });
}
